<template src="./template.html"></template>
<script>
  import {form} from 'lvgs-vue-modules';
  import _ from 'lodash';

  export default _.assign(form.check, {
    watch: {
      formValue() {
        if (this.isValidate) {
          const validateValue = this._getValidateValue();

          // validateのリセット
          if (this.checkTypeIsArray) {
            const currentValidates = this.$store.getters.getIsPassValidateByKey(
              this.refNames.parent
            );

            _.each(currentValidates, (item, index) => {
              const valueName = this._indexedName(index);

              if (_.isNull(_.get(validateValue, valueName, null))) {
                this.$store.commit('deleteValidate', valueName);
              }
            });
          }
        }
      }
    }
  });
</script>
